import React, {Component} from 'react'
import { DropTarget } from 'react-dnd'
import DraggableBox from './DraggableBox'
import snapToGrid from './snapToGrid'
import CustomDragLayer from './CustomDragLayer'

const styles = {
	width: '100%',
	height: '100%',
	border: 'none',
	position: 'relative',
}

const boxTarget = {
	drop(props,monitor,component) {
		if (!component) {
			return
		}
		const delta =  {x:monitor.getDifferenceFromInitialOffset().x,y:monitor.getDifferenceFromInitialOffset().y}
		const item = monitor.getItem()
		
		let left = Math.round(item.left + delta.x)
		let top = Math.round(item.top + delta.y)
		if (props.snapToGrid) {
			;[left, top] = snapToGrid(left, top)
		}
		
		item.top = top
		item.left = left
		component.moveBox(item)
		document.getElementById('box-item-'+item.id).focus()
		document.body.style.overflow = 'hidden'
	}
}

function collect(connect,monitor) {
    return {
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver(),
    }
}


class Container extends Component {
	constructor(...args) {
        super(...args)
		this.state = {itemsDrop:[],isActive:undefined,margin:35}
	}

	componentDidMount() {
		this.setState({itemsDrop:this.props.dataDrop})
		this.props.onResetDataDrop()
	}

	componentWillReceiveProps(newProps) {
		if (newProps.checkDataDrop&&newProps.checkDataDrop!==this.props.checkDataDrop) {
			this.setState({itemsDrop:newProps.dataDrop,margin:newProps.margin})
			this.props.onResetDataDrop()
		}
	}

	moveBox(item) {
		let {sizePage} = this.props
		let checkTop = (sizePage=='a4-onlineview'?1253:1029)
		let checkLeft = (sizePage=='a4-onlineview'?907:793)
		let {itemsDrop} = this.state
		const isAlready = itemsDrop.findIndex(x => x.id==item.id)
		if (isAlready==-1) {
			item.left = 450
			item.top = 450
			itemsDrop.push(item)
		} else {
			if (item.left<0||item.left>checkLeft) {
				if (item.left<0)
					itemsDrop[isAlready].left = 0
				else if (item.left>checkLeft)
					itemsDrop[isAlready].left = checkLeft
			} else {
				itemsDrop[isAlready].left = item.left
			}

			if (item.top<0||item.top>checkTop) {
				if (item.top<0)
					itemsDrop[isAlready].top = 0
				else if (item.top>checkTop)
					itemsDrop[isAlready].top = checkTop
			} else {
				itemsDrop[isAlready].top = item.top
			}
		}	
		this.setState({itemsDrop:itemsDrop,isActive:item.id})
		if (this.props.handleDrop!=undefined)
			this.props.handleDrop(itemsDrop)
	}

	onBoxDown(id,keyCode) {
		let {sizePage} = this.props
		let checkTop = (sizePage=='a4-onlineview'?1253:1029)
		let checkLeft = (sizePage=='a4-onlineview'?907:793)
		let {itemsDrop} = this.state
		const key = itemsDrop.findIndex(x => x.id==id)
		if (keyCode==37) { // left
			if (itemsDrop[key].left>0)
				itemsDrop[key].left = itemsDrop[key].left - 1
		} else if (keyCode==38) { // top
			if (itemsDrop[key].top>0)
				itemsDrop[key].top = itemsDrop[key].top - 1
		} else if (keyCode==39) { // right
			if (itemsDrop[key].left<checkLeft)
				itemsDrop[key].left = itemsDrop[key].left + 1
		} else if (keyCode==40) { // bottom
			if (itemsDrop[key].top<checkTop)
				itemsDrop[key].top = itemsDrop[key].top + 1
		}
		this.setState({itemsDrop:itemsDrop})
		if (this.props.handleDrop!=undefined)
			this.props.handleDrop(itemsDrop)
	}

	onBoxActive(id) {
		this.setState({isActive:id})
	}

	onBoxBlur() {
		this.setState({isActive:undefined})	
	}

	onItemDeleteClick(id) {
		this.setState({isActive:undefined})
		if (this.props.onItemDeleteClick!=undefined)
			this.props.onItemDeleteClick(id)
	}

	onExpandClick(id) {
		let {itemsDrop} = this.state
		let copyItemDrop = JSON.parse(JSON.stringify(itemsDrop))
		let {items} = this.props
		const key = copyItemDrop.findIndex(x=>x.id==id)
		if (key!=-1) {
			const objArr = copyItemDrop[key].field.split('.')
			const left = copyItemDrop[key].left
			const top = copyItemDrop[key].top
			let i = 1
			items.forEach((item,index)=>{
				const _objArr = item.field.split('.')
				if ((objArr.length>0&&_objArr.length>0)&&(objArr.length==_objArr.length)) {
					if ((objArr[0]==_objArr[0])&&(objArr[objArr.length-1]==_objArr[_objArr.length-1])&&(item.field!=copyItemDrop[key].field)&&(item.id>copyItemDrop[key].id)&&(copyItemDrop.findIndex(x=>x.id==item.id)==-1)) {
						item.left = left
						item.top = (this.state.margin*i)+top
						copyItemDrop.push(item)
						i++
					}
				}
			})
			if (this.props.onExpandClick!=undefined) {
				this.props.onExpandClick(copyItemDrop,id,copyItemDrop[key])
			}	
		}
	}

	onBoxDbClick(id) {
		if (this.props.onBoxDbClick!=undefined)
			this.props.onBoxDbClick(id)
	}

	renderBox(item,key,index) {
		const {isActive} = this.state
		return(
			<DraggableBox 
				key={index} 
				id={key} 
				isArray={item.isArray}
				isActive={isActive}
				{...item}
				showField={this.props.showField} 
				onBoxDown={this.onBoxDown.bind(this)} 
				onBoxActive={this.onBoxActive.bind(this)} 
				onBoxBlur={this.onBoxBlur.bind(this)} 
				onItemDeleteClick={this.onItemDeleteClick.bind(this)}
				onExpandClick={this.onExpandClick.bind(this)}
				onBoxDbClick={this.onBoxDbClick.bind(this)}
			/>
		)
    }
    
    render() {
		const {connectDropTarget} = this.props
		let {itemsDrop} = this.state
		return connectDropTarget(
			<div className='drop-config-item font-print' style={styles}>
				{itemsDrop.map((ritem,rindex)=>{
					return(this.renderBox(ritem,ritem.id,rindex))
				})}
				<CustomDragLayer snapToGrid={false} />
			</div>
		)
	}
}
Container.defaultProps = {
	dataDrop:[]
}
export default DropTarget('box',boxTarget,collect)(Container);


// WEBPACK FOOTER //
// ./src/view/print/paperconfig/Container.js